import type {FC} from 'react';
import useGlobalStore from '../../store/useGlobalStore.ts';
import Popup from './popup/Popup.tsx';
import Alert from './alert/Alert.tsx';
import Modal from './Modal.tsx';
import {createPortal} from 'react-dom';

const ModalRenderer: FC = () => {
    const {stack, isInStack} = useGlobalStore();

    return createPortal(
        <>
            {stack.map((item) => {
                const isOpen = isInStack(item.id);

                switch (item.type) {
                    case 'popup':
                        return (
                            <Modal key={item.id} isOpen={isOpen} itemId={item.id}>
                                <Popup key={item.id} item={item} />
                            </Modal>
                        );
                    case 'alert':
                        return (
                            <Modal key={item.id} isOpen={isOpen} itemId={item.id}>
                                <Alert key={item.id} item={item} />
                            </Modal>
                        );
                    case 'modal': {
                        const Component = item.component;
                        return (
                            <Modal key={item.id} isOpen={isOpen} itemId={item.id}>
                                <Component {...item.props} onClose={() => {}} />
                            </Modal>
                        );
                    }
                    default:
                        return null;
                }
            })}
        </>,
        document.body
    );
};

export default ModalRenderer;
